module.exports = __webpack_public_path__ + "media/images/lesson_7/nini_sem_sucesso-f7bbe8f1089980a293b8377c27e99cfd.png";